import { render, staticRenderFns } from "./DonutChart36.vue?vue&type=template&id=9e7f0cb6&scoped=true"
import script from "./DonutChart36.vue?vue&type=script&lang=js"
export * from "./DonutChart36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7f0cb6",
  null
  
)

export default component.exports